import { getDiffArray, filterDiffFunction } from './chunk-WTGT4IDV.mjs';
import { selectCurrentSettingsData, selectPrepStationsSettingsForDetailsScreen } from './chunk-67X7HZEW.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import difference from 'lodash/difference';

var PrepStationFieldLabels = /* @__PURE__ */ ((PrepStationFieldLabels2) => {
  PrepStationFieldLabels2[PrepStationFieldLabels2["active"] = 0] = "active";
  PrepStationFieldLabels2[PrepStationFieldLabels2["name"] = 1] = "name";
  PrepStationFieldLabels2[PrepStationFieldLabels2["posName"] = 2] = "posName";
  PrepStationFieldLabels2[PrepStationFieldLabels2["printerIds"] = 3] = "printerIds";
  return PrepStationFieldLabels2;
})(PrepStationFieldLabels || {});
var DefaultPrepStationLabels = /* @__PURE__ */ ((DefaultPrepStationLabels2) => {
  DefaultPrepStationLabels2[DefaultPrepStationLabels2["defaultPrepStationId"] = 0] = "defaultPrepStationId";
  return DefaultPrepStationLabels2;
})(DefaultPrepStationLabels || {});
var returnLabel = (field) => {
  if (field in PrepStationFieldLabels || field in DefaultPrepStationLabels) {
    return i18n_config_default.t(
      `app.modals.prepStationsDiffModal.${field}`
    );
  }
};
var diffPrepStationsFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const prepStationsDiff = generatePrepStationsObj(diffArray, state);
    const prepStations = selectCurrentSettingsData(state).prepStations;
    const defaultPrepStation = getDiffArray(
      diffArray,
      returnLabel,
      DefaultPrepStationLabels,
      1
    ).map((diff) => {
      var _a;
      if (diff.field === "defaultPrepStationId") {
        return __spreadProps(__spreadValues({}, diff), {
          textValue: ((_a = prepStations[diff.value]) == null ? void 0 : _a.name) || ""
        });
      }
      return diff;
    });
    return {
      prepStations: prepStationsDiff,
      defaultPrepStation
    };
  }
  return null;
};
var getPrinterIdsDiff = (oldPrinterIds, newPrinterIds) => {
  const addedIds = difference(newPrinterIds, oldPrinterIds);
  const removedIds = difference(oldPrinterIds, newPrinterIds);
  const baseChange = {
    field: "printerIds",
    label: returnLabel("printerIds") || "",
    value: []
  };
  const changes = [];
  addedIds.forEach((id) => {
    changes.push(__spreadProps(__spreadValues({}, baseChange), {
      value: [
        {
          action: "add",
          value: id
        }
      ]
    }));
  });
  removedIds.forEach((id) => {
    changes.push(__spreadProps(__spreadValues({}, baseChange), {
      value: [
        {
          action: "remove",
          value: id
        }
      ]
    }));
  });
  return changes;
};
var generatePrepStationsObj = (diffArray, state) => {
  const data = state.settings.changeData.data.prepStations;
  const prepStations = [];
  const prepStationsWithPrinterChangesIndexes = /* @__PURE__ */ new Set();
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ diffLength }) => {
        if (diff.path.includes("printerIds")) {
          const id = Number(diff.path[1]);
          let index = prepStations.findIndex(
            (prepStation) => prepStation.id === id
          );
          if (index === -1) {
            prepStations.push({
              id,
              label: data[id].name,
              action: "update",
              changes: []
            });
            index = prepStations.length - 1;
          }
          prepStationsWithPrinterChangesIndexes.add(index);
        } else if (diff.kind === "A" /* ARRAY_CHANGE */) {
          const change = diff.item;
          if ((change == null ? void 0 : change.kind) === "D" /* DELETED_FIELD */ || (change == null ? void 0 : change.kind) === "N" /* ADDED_FIELD */) {
            const id = Number(diff.path[1]);
            const customNewDiff = {
              field: diff.path[2],
              label: returnLabel(diff.path[2]) || "",
              value: [
                {
                  action: (change == null ? void 0 : change.kind) === "N" /* ADDED_FIELD */ ? "add" : "remove",
                  value: (change == null ? void 0 : change.kind) === "N" /* ADDED_FIELD */ ? change.rhs : change.lhs
                }
              ]
            };
            if (!prepStations.find(
              (prepStation) => prepStation.id === id && prepStation.action === "update"
            )) {
              prepStations.push({
                id,
                label: data[id].name,
                action: "update",
                changes: [customNewDiff]
              });
            } else {
              for (const [i, prepStation] of prepStations.entries()) {
                if (prepStation.id === id) {
                  prepStations[i].changes = [
                    ...prepStation.changes,
                    customNewDiff
                  ];
                  break;
                }
              }
            }
          }
        } else if (diff.kind === "N" /* ADDED_FIELD */) {
          const generateCustomNewAddedDiff = (printerId) => ({
            field: "printerIds",
            label: returnLabel("printerIds") || "",
            value: [
              {
                action: "add",
                value: printerId
              }
            ]
          });
          const differences = diff.rhs;
          const changes = Object.entries(differences).map(([prepStationField, prepStationValue]) => {
            return {
              field: prepStationField,
              label: returnLabel(prepStationField),
              value: prepStationValue
            };
          }).filter((change) => change.field !== "printerIds");
          const printerIds = differences ? differences.printerIds : [];
          printerIds.forEach(
            (id) => changes.push(generateCustomNewAddedDiff(id))
          );
          prepStations.push({
            id: diff.rhs.id,
            label: diff.rhs.name,
            action: "add",
            changes
          });
        } else if (diff.kind === "D" /* DELETED_FIELD */) {
          prepStations.push({
            id: diff.lhs.id,
            label: diff.lhs.name,
            action: "remove",
            changes: []
          });
        } else if (diff.kind === "E" /* EDITED_FIELD */ && diffLength === 3) {
          const id = Number(diff.path[1]);
          const customNewDiff = {
            field: diff.path[2],
            label: returnLabel(diff.path[2]) || "",
            value: diff.rhs
          };
          if (!prepStations.find(
            (prepStation) => prepStation.id === id && prepStation.action === "update"
          )) {
            prepStations.push({
              id,
              label: data[id].name,
              action: "update",
              changes: [customNewDiff]
            });
          } else {
            for (const [i, prepStation] of prepStations.entries()) {
              if (prepStation.id === id) {
                prepStations[i].changes = [
                  ...prepStation.changes,
                  customNewDiff
                ];
                break;
              }
            }
          }
        }
      },
      returnLabel
    )
  );
  prepStationsWithPrinterChangesIndexes.forEach((index) => {
    var _a, _b, _c, _d, _e;
    const prepStationDiff = prepStations[index];
    const newPrinterIds = (_a = data[prepStationDiff.id].printerIds) != null ? _a : [];
    const oldPrinterIds = (_e = (_d = (_c = (_b = selectPrepStationsSettingsForDetailsScreen(state)) == null ? void 0 : _b.prepStations) == null ? void 0 : _c[prepStationDiff.id]) == null ? void 0 : _d.printerIds) != null ? _e : [];
    const printerIdsDiff = getPrinterIdsDiff(oldPrinterIds, newPrinterIds);
    prepStations[index].changes = [
      ...prepStations[index].changes,
      ...printerIdsDiff
    ];
  });
  return prepStations;
};

export { diffPrepStationsFactory };
